<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col>
        <b-card :title="$t('account.billing')">
          <fields group="main" />
        </b-card>
      </b-col>
      <b-col />
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <fields group="info" />
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <fields group="address" />
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button
        v-if="showCancelButton"
        type="button"
        variant="light"
        class="ml-2"
        @click="cancel"
      >
        {{ $t('general.cancel') }}
      </b-button>
      <b-button
        v-if="model.is_default === false && updating && $allows('administer')"
        class="ml-2"
        type="button"
        variant="danger"
        @click="deleteBilling"
      >
        <i class="icon-trash" /> {{ $t('general.delete') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import Api from './Api'

export default {
  name: 'BillingInfoForm',

  mixins: [ResourceFormMixin],
  props: {
    showCancelButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  mounted() {
    this.loadForm().then(() => {
      this.setFieldGroup('main', ['name', 'stripe_key', 'stripe_secret'])
      this.setFieldGroup('info', [
        'company_name',
        'company_number',
        'contact_name',
        'contact_email',
        'vat_number',
        'tax_number',
      ])
      this.setFieldGroup('address', [
        'country',
        'state',
        'city',
        'zip',
        'address_line1',
        'address_line2',
      ])
    })
  },

  methods: {
    api() {
      return new Api()
    },
    submit() {
      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },
    async deleteBilling() {
      const answer = !!(await this.$alert.question(
        this.$t('billing_info.messages.confirm_deleting'),
      )).value
      if (answer === false) {
        return
      }

      this.$uiBlocker(
        this.api()
          .destroy(this.model.id)
          .then(result => {
            this.$toast.success(result.message)
            this.cancel()
          }),
        this.$el,
      )
    },
  },
}
</script>
